<template>
  <div class="bottom">
    <div class="content_mid clearfix">
      <div class="b_left">
        <div class="bottom_logo">
          <img src="../assets/images/bottom_logo.jpg" alt />
        </div>
        <div class="sub" @click="jumeVolunteer">
          成为志愿者
        </div>
        <p>CopyRight©新力公益基金会版权所有</p>
        <p><a target="_Blank" href="http://gongyi.la/">Powered By Gongyi.la</a></p>
      </div>
      <div class="b_center clearfix">
        <dl>
          <dt>关于基金会</dt>
          <dd>
            <router-link to="/aboutus">关于基金会</router-link>
          </dd>
        </dl>
        <dl>
          <dt>基金会资讯</dt>
          <dd>
            <router-link to="/information/list?id=3">最新消息</router-link>
          </dd>
          <dd>
            <router-link to="/information/list?id=2">荣誉奖项</router-link>
          </dd>
          <dd>
            <router-link to="/information/list?id=1">媒体报道</router-link>
          </dd>
          <dd>
            <router-link to="/information/list?id=4">信息披露</router-link>
          </dd>
          <dd>
            <router-link to="/information/list?id=5">志愿者双月刊</router-link>
          </dd>
        </dl>
        <dl>
          <dt>基金会项目</dt>
          <dd>
            <router-link to="/projects/list?id=1">紧急救灾</router-link>
          </dd>
          <dd>
            <router-link to="/projects/list?id=3">儿童福利</router-link>
          </dd>
          <dd>
            <router-link to="/projects/list?id=4">边缘救助</router-link>
          </dd>
          <dd>
            <router-link to="/projects/list?id=5">行业促进</router-link>
          </dd>
          <dd>
            <router-link to="/projects/list?id=2">新·扶贫计划</router-link>
          </dd>
        </dl>
        <dl>
          <dt>志愿者活动</dt>
          <dd>
            <router-link to="/activity/list">志愿者活动</router-link>
          </dd>
        </dl>
        <dl>
          <dt>合作伙伴</dt>
          <dd>
            <router-link to="/partner/list">合作伙伴</router-link>
          </dd>
        </dl>
      </div>
      <div class="b_right">
        <div>
          <img class="qr-code" src="../assets/images/xcx.png" alt />
          <div class="qr-title">机构小程序</div>
        </div>
        <div>
          <img class="qr-code" src="../assets/images/gzh.jpg" alt />
          <div class="qr-title">机构公众号</div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <a href="http://www.beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">沪ICP备19040785号-1</a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      jumeVolunteer() {
        this.$api.getVolunteerApplyStatus({}).then(res => {
          switch (res.result) {
            case "NotRegister":
              this.$router.push({
                name: 'userProtocol'
              })
              break;
            case "UnOffcialApproved":
              this.$router.push({
                name: 'realName'
              })
              break;
            case "OffcialReject":
              this.$router.push({
                name: 'realName',
                query: {
                  isoffcialReject: true
                }
              })
              break;
            case "OffcialApply":
              this.$alert('您已提交申请，请等待审核', '提示', {
                confirmButtonText: '确定',
                callback: action => {}
              });
              break;
            case "OffcialApproved":
              this.$alert('您已完成实名认证', '提示', {
                confirmButtonText: '确定',
                callback: action => {}
              });
              break;
          }
        }).catch(err => {
          this.$router.push({
            name: 'userProtocol'
          })
        })
      }
    }
  };

</script>


<style lang="scss" scoped>
  .bottom {
    width: 100%;
    min-width: 1200px;
    padding-bottom: 40px;
    background: #f2efe9;
    padding-top: 70px;

    .b_left {
      width: 300px;
      float: left;

      .bottom_logo {
        width: 210px;
        height: 45px;

        img {
          width: 210px;
          height: 45px;
        }
      }

      .sub {
        display: block;
        width: 127px;
        height: 40px;
        border-radius: 5px;
        margin-top: 35px;
        font-size: 18px;
        color: #fff;
        background: #a3c31d;
        text-align: center;
        line-height: 40px;
        text-decoration: none !important;
        cursor: pointer;
        font-style: normal;

        &:hover {
          background: #a3c31d - 9%;
        }

        &:active {
          background: #a3c31d - 15%;
        }
      }

      p:first-of-type {
        margin-top: 35px;
        color: #333333;
      }


      a:hover {
        text-decoration: underline;
      }

    }

    .b_center {
      float: left;

      dl {
        width: 120px;
        text-align: left;
        float: left;

        dt {
          font-size: 16px;
          font-weight: bold;
        }

        dd {
          color: #333333;
          margin-top: 20px;
          font-size: 14px;
        }
      }
    }

    .b_right {
      float: right;
      display: flex;

      .qr-title {
        margin: 5px 0 0 15px;
        text-align: center;
      }

      img {
        width: 106px;
        height: 110px;
        margin-left: 15px;

        &.qr-code {
          box-sizing: border-box;
          border: 5px solid #ffffff;
        }
      }
    }
  }

  .copyright {
    text-align: center;
    margin-top: 20px;

    a {
      font-size: 16px;
      color: #333;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue